import { EndorsementKey, type EndorsementConfig } from '../../types';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.EquipmentBreakdownEndorsement,
  label: 'Equipment Breakdown Coverage',
  description:
    'Add this coverage to protect your business equipment from unexpected events like power surges or outages.',
  recommended: true,
};
